import React from "react";

const Widget = ({ title, subtitle }: any) => {
  return (
    <div className="shadow-lg px-4 py-6 w-full bg-white">
      <p className="text-sm w-max text-gray-700 font-semibold border-b border-gray-200">
        {title} { subtitle && <small>{subtitle}</small>}
      </p>
      <div className="flex items-end space-x-2 my-6">
        <p className="text-5xl text-black font-bold">
          N/A
        </p>
      </div>
      <div className="">
        N/A
      </div>
    </div>
  );
}

export default Widget